module.exports = __webpack_public_path__ + "static/media/bg-right-img-4.36c4957a.jpg";